import React from 'react';
import '../../css/footer.css';
import {Container, Row, Col } from 'react-bootstrap';


class Footer extends React.Component{
    render(){
        return(
            <div className="mt-5">
                <div className="Footer pt-5 pb-5">
                    <Container>
                        <Row>
                            <Col sm={5} className="pt-3 pb-5">
                                <img
                                    src="../images/logolagot.png"
                                    className="d-block mx-auto img-fluid"
                                    alt="React Bootstrap logo"
                                />
                            </Col>
                            <Col className="pt-3 text-center">
                                <h2 className="text-center">Kenapa Harus di Kami</h2>

                                <Row className="mt-3">
                                    <Col sm={2}>
                                        <img
                                            src="../images/cod.png"
                                            height="60"
                                            className="d-block mx-auto"
                                            alt="React Bootstrap logo"
                                        />
                                    </Col>
                                    <Col className="kelebihan">
                                        <p><strong>Bisa Bayar di Tempat</strong><br></br>barang baru sampai baru bayar, jadi super aman</p>
                                    </Col>
                                </Row>

                                <Row className="mt-3">
                                    <Col sm={2}>
                                        <img
                                            src="../images/quality.png"
                                            height="60"
                                            className="d-block mx-auto"
                                            alt="React Bootstrap logo"
                                        />
                                    </Col>
                                    <Col className="kelebihan">
                                        <p><strong>Kualitas Terjamin</strong><br></br>Harga murah tapi kualitas tidak murahan</p>
                                    </Col>
                                </Row>

                                <Row className="mt-3">
                                    <Col sm={2}>
                                        <img
                                            src="../images/return.png"
                                            height="60"
                                            className="d-block mx-auto"
                                            alt="React Bootstrap logo"
                                        />
                                    </Col>
                                    <Col className="kelebihan">
                                        <p><strong>Barang Bisa Dikembalikan</strong><br></br>Jika barang yang diterima dalam keadaan cacat atau salah ukuran</p>
                                    </Col>
                                </Row>

                                <Row className="mt-3">
                                    <Col sm={2}>
                                        <img
                                            src="../images/dompet.png"
                                            height="60"
                                            className="d-block mx-auto"
                                            alt="React Bootstrap logo"
                                        />
                                    </Col>
                                    <Col className="kelebihan">
                                        <p><strong>Pelayanan Terbaik</strong><br></br>Anda akan dilayani lansung oleh cs kami hingga proses selesai</p>
                                    </Col>
                                </Row>

                            </Col>
                        </Row>
                    </Container>
                </div>
                <div className="foot pb-4 pt-4">
                    <Container className="text-center">
                         <small>Copyright &copy;2020 Sepatu cod</small>
                    </Container>
                </div>
            </div>
        );
    }
}

export default Footer;